import { Ipad, Mac, Phone, OpenLeft, OpenRight } from "../../../icons";
import Pages from "./pages";
import Edit from "./edit";
import styles from "./styles.module.css";
import { useParams } from "react-router-dom";
export default function Header({ sidebar, zoom, width, height, editor }) {
  const { type } = useParams();
  const handleZoomInput = (e) => {
    const num = parseFloat(e.target.value);
    if (isNaN(num)) {
      zoom.set(100);
    } else {
      zoom.set(num);
    }
  };
  const handleWidthInput = (e) => {
    const num = parseFloat(e.target.value);
    if (isNaN(num)) {
      width.set(1200);
    } else {
      width.set(num);
    }
  };
  const handleHeightInput = (e) => {
    const num = parseFloat(e.target.value);
    if (isNaN(num)) {
      height.set(300);
    } else {
      height.set(num);
    }
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        height: 48,
        alignItems: "center",
      }}
    >
      <Edit />

      <Pages />
      {type === "pages" && (
        <div className={styles.sizeContainer}>
          <Mac
            onClick={() => width.set(1200)}
            className={
              width.value === 1200
                ? `${styles.icon} ${styles.active}`
                : styles.icon
            }
          />
          <Ipad
            onClick={() => width.set(1024)}
            className={
              width.value === 1024
                ? `${styles.icon} ${styles.active}`
                : styles.icon
            }
          />
          <Phone
            onClick={() => width.set(380)}
            className={
              width.value === 380
                ? `${styles.icon} ${styles.active}`
                : styles.icon
            }
          />
          <input
            style={{ width: 60, textAlign: "right" }}
            className="input"
            onChange={handleWidthInput}
            value={width.value}
          />
        </div>
      )}
      {type === "components" && (
        <div className={styles.compContainer}>
          <div className={styles.inputLabel}>
            <div style={{ marginRight: 4 }}>Width</div>
            <input
              style={{ width: 60, textAlign: "right" }}
              className="input"
              onChange={handleWidthInput}
              value={width.value}
            />
          </div>
          <div className={styles.inputLabel}>
            <div style={{ marginRight: 4 }}>Height</div>
            <input
              style={{ width: 60, textAlign: "right" }}
              className="input"
              onChange={handleHeightInput}
              value={height.value}
            />
          </div>
        </div>
      )}
      <div className={styles.inputLabel}>
        <input
          style={{ width: 60, textAlign: "right" }}
          className="input"
          onChange={handleZoomInput}
          value={zoom.value}
        />
      </div>
      <p style={{ fontFamily: "var(--font)", margin: 0, paddingLeft: 0 }}>%</p>

      <div style={{ flexGrow: 1 }} />
      {editor.value ? (
        <OpenRight
          onClick={() => editor.set(false)}
          className={`${styles.openIcon} ${styles.active}`}
        />
      ) : (
        <OpenLeft
          onClick={() => editor.set(true)}
          className={styles.openIcon}
        />
      )}
    </div>
  );
}
